interface SiteMetadata {
  siteUrl: string;
  title: string;
  description: string;
  keywords: string;
}

interface SiteConfig {
  siteMetadata: SiteMetadata;
}

export const config = {
  gbetAddress:
    "https://d4atlppoo4cbufhshamtdgouknbxxbgvis5u2g2uxj3yhkszdbma.arweave.net/HwE1ve53BBoU8jgZMZnUU0N7hNVEu00bVLp3g6pZGFg",
};

export const siteConfig: SiteConfig = {
  siteMetadata: {
    siteUrl: "https://gangstabet.io",
    title: "GangstaBet: A Digital Collectible",
    description:
      "GangstaBet is a collection of 5000 unique digital collectibles in the ICON blockchain",
    keywords: "blockchain, crypto, wallet",
  },
}; 